import './App.css';
import {
  Routes,
  BrowserRouter as Router,
  Route,
} from 'react-router-dom';
import { useState } from 'react';
import Sidebar from './components/MainContainer.jsx/Sidebar';
import Login from './components/Login';
import Home from './components/Home';
import Context from './context-api/useContext';
import Navbar from './components/Navbar';
import Credit from './components/Credit';
import Funding from './components/Funding';
import Account from './components/Account';
import BlogPage2 from './components/BlogPage2';
import Drafts from './components/Drafts';
import FundingShedule from './components/FundingShedule';
import Createshedule from './components/CreateScedule';
import Addload from './components/AddLoad';
import Fundingpayment from './components/FundingPayment';
import Notification from './components/Notification';
import ForgotPassword from './components/ForgotPassword';
import Document from './components/Document';
import LoardBoard from './components/LoardBoard';
import DashboardAnalytics from './components/DashboardAnalytics';
import TestLoadboard from './components/TestLoadboard';
import DetailedPage from './components/DetailedPage';
import LoardBoard1 from './components/LoadBoard1';
import { useLocation } from 'react-router-dom';
import  {LoadScript}  from "@react-google-maps/api";
import SinglepointLoads from './components/SinglepointLoads';
import Header from './components/MainContainer.jsx/Header';
import Dashboard from './components/Dashboard';
function Layout() {
   const userType = sessionStorage.getItem('user_type');
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const baseClasses = "flex-shrink-0 flex flex-col transition-all duration-500 h-screen ovrflow-hidden";
  const closedClasses = sidebarOpen ? "w-[45%] max-w-[290px]" : "w-[0px]";
  const location = useLocation();
const hideSidebarRoutes = ["/login", "/forgotpassword"]; // pages where sidebar should be hidden
  const shouldShowSidebar = !hideSidebarRoutes.includes(location.pathname);
  return (
        <div className="flex h-screen bg-white">
       {shouldShowSidebar && (
      <div className={`${baseClasses} ${closedClasses} sticky top-0`}>
        <div className="">
          <Sidebar />
        </div>
      </div>
       )}
      {/* Main Content Section */}
      
{/* bg-[#F7FAFE] */}
{/* #f2f2f2     #ecf0fff5   #eeeeeef5  #f8f9fbff*/}
{/* bg-[#e8f6ff]  gray*/}
      <div className="flex-1 w-[55%] bg-[#F8F8F8] px-10  overflow-y-auto h-screen">
        <Routes>

           {/* <Route path="/login" element={<Login />} /> */}
           <Route path="/" element={<Dashboard />} /> 
           <Route path="/blogpage2" element={<BlogPage2 />} />
           <Route path="/credit" element={<Credit />} />
           <Route path="/funding" element={<Funding />} />
           <Route path="/funding/drafts" element={<Drafts />} />
           <Route path="/funding/schedule" element={<FundingShedule />} />
           <Route path="/funding/create_shedule" element={<Createshedule />} /> 
           <Route path="/funding/addLoad" element={<Addload />} />
           <Route path="/document" element={<Document />} />
           <Route path="/funding/payment" element={<Fundingpayment />} />
           <Route path="/account" element={<Account />} />
           <Route path="/loadboard" element={<LoardBoard />} />
           <Route path="/notification" element={<Notification />} />
           {/* <Route path="/forgotpassword" element={<ForgotPassword />} /> */}
           <Route path="/dashboard-analytics" element={<DashboardAnalytics />} />
           <Route path ="/loadboard/singlepointLoads" element ={<SinglepointLoads />} />
           {/* <Route path = "/dashboard" element = {<Dashboard />} /> */}
           {/* <Route path = "/home" element = {<HomeContainer />} /> */}
          
         
        </Routes>
      </div>
       </div>
  );
}


function App() {
  return (
    <>
     {/* <Header /> */}
    <Context>
      <Router basename="/web">
       <Routes>
          {/* Login & ForgotPassword are OUTSIDE Layout */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgotpassword" element={<ForgotPassword />} />

          {/* Everything else goes inside Layout */}
          <Route path="/*" element={<Layout />} />
        </Routes>
        {/* <Layout /> */}
      </Router>
    </Context>
    </>
  );
}

export default App;
